import { useMyOrg, useOrganizationByPath } from '../layouts/AppStateContextLayout/utils'
import { useRecordContext } from '../pages/RecordPage/Record/Context'

export const useOrgUuid = () => {
  const recordContext = useRecordContext()
  const orgSlugMetadata = useOrganizationByPath()
  const myOrg = useMyOrg()
  return recordContext?.orgUuid || orgSlugMetadata?.uuid || myOrg?.uuid || ''
}
